/** Before several chats: one token per scope. Still read, never written. */
const LEGACY_TOKEN_PREFIX = "customer-chat-visitor-v1:";
/** JSON list of chat tokens, newest first. Prefix named in the privacy notice (`privacy-content.ts`). */
const TOKENS_PREFIX = "customer-chat-visitor-v1:chats:";
/** Same cap as the server reads (`visitor_chat_list.ts`). */
const MAX_TOKENS = 30;

/** Where a visitor's chats are kept: per help center or per website. */
export function visitorChatScope(
  channel:
    | { readonly kind: "help_center"; readonly orgSlug: string }
    | { readonly kind: "website"; readonly siteKey: string },
): string {
  const scope = channel.kind === "website" ? `embed:${channel.siteKey}` : channel.orgSlug;
  return scope.trim().toLowerCase();
}

function readItem(key: string): string | null {
  if (typeof window === "undefined") return null;
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
}

function parseTokens(raw: string | null): string[] {
  if (raw === null) return [];
  try {
    const parsed: unknown = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.filter((t): t is string => typeof t === "string" && t.trim().length > 0) : [];
  } catch {
    return [];
  }
}

/** The visitor's chat tokens in this scope, last written first. */
export function readVisitorChatTokens(scope: string): string[] {
  const tokens = parseTokens(readItem(`${TOKENS_PREFIX}${scope}`));
  const legacy = readItem(`${LEGACY_TOKEN_PREFIX}${scope}`)?.trim() ?? "";
  if (legacy.length > 0 && !tokens.includes(legacy)) tokens.push(legacy);
  return tokens.slice(0, MAX_TOKENS);
}

/** New chat or new message: the token moves to the front. */
export function rememberVisitorChatToken(scope: string, token: string): void {
  const next = [token, ...readVisitorChatTokens(scope).filter((t) => t !== token)].slice(0, MAX_TOKENS);
  try {
    window.localStorage.setItem(`${TOKENS_PREFIX}${scope}`, JSON.stringify(next));
  } catch {
    /* private mode / quota — non-fatal */
  }
}
